import { openOverlayByKey } from './overlay'

/**
 * Newsletter behaviour:
 *
 * 1. Responsive submit/email labels — on small screens the submit button shows
 *    "ok" and the email placeholder shortens to "E-Mail". Scoped per form via
 *    form.querySelector, so it works for every newsletter instance (footer +
 *    overlay) regardless of their (suffixed) element ids.
 *
 * 2. /newsletter link interception — any link pointing at {home_url}/newsletter
 *    opens the newsletter overlay instead of navigating, so editors can link the
 *    overlay from WYSIWYG text, footer columns or menus. There is no dedicated
 *    toggle button; this interception is the only trigger.
 */

const SMALL_MQ = '(max-width: 699px)'

const setupResponsiveLabels = (form) => {
    const submit = form.querySelector('input[type="submit"]')
    const email  = form.querySelector('input[type="email"]')
    if (!submit && !email) return

    const submitFull = submit ? submit.value : ''
    const emailFull  = email ? email.getAttribute('placeholder') : ''
    const mq = window.matchMedia(SMALL_MQ)

    const apply = (small) => {
        if (submit) submit.value = small ? 'ok' : submitFull
        if (email)  email.setAttribute('placeholder', small ? 'E-Mail' : emailFull)
    }

    apply(mq.matches)
    mq.addEventListener('change', (e) => apply(e.matches))
}

document.querySelectorAll('[data-newsletter-form]').forEach(setupResponsiveLabels)

// --- /newsletter link interception ---------------------------------------

const stripTrailingSlash = (url) => url.replace(/\/+$/, '')

const homeUrl       = window.php_vars?.homeUrl || `${window.location.origin}/`
const newsletterUrl = stripTrailingSlash(homeUrl) + '/newsletter'

document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href]')
    if (!link) return
    if (stripTrailingSlash(link.href) !== newsletterUrl) return

    e.preventDefault()
    openOverlayByKey('newsletter')
})
